module.exports = __webpack_public_path__ + "img/audio-mark7.2af0e294.png";